<div class="space-y-6">
  <app-page-header
    [title]="'wallets.monWallet' | t"
    [subtitle]="'wallets.tes2ComptesNawam' | t"
  >
    @if (snapshot(); as snap) {
      <div slot="actions" class="flex flex-wrap gap-2">
        <button
          type="button"
          (click)="openWithdraw()"
          [disabled]="(snap.withdrawableBalance ?? 0) <= 0"
          [title]="'wallets.retirerDeTonSolde' | t"
          class="inline-flex items-center justify-center gap-2 rounded-lg border border-brand-300 px-5 py-2.5 text-sm font-medium text-brand-700 transition hover:bg-brand-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-brand-800 dark:text-brand-400 dark:hover:bg-brand-500/10"
        >
          Retirer
        </button>
        <button
          type="button"
          (click)="openTopup()"
          class="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-5 py-2.5 text-sm font-medium text-white shadow-theme-xs transition hover:bg-brand-600"
        >
          <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor"><path d="M10 3.75a.75.75 0 0 1 .75.75v4.75h4.75a.75.75 0 0 1 0 1.5H10.75v4.75a.75.75 0 0 1-1.5 0V10.75H4.5a.75.75 0 0 1 0-1.5h4.75V4.5a.75.75 0 0 1 .75-.75Z"/></svg>
          {{ 'wallets.rechargerMonCredit' | t }}
        </button>
      </div>
    }
  </app-page-header>

  @if (flash()) {
    <div class="flex items-start justify-between gap-3 rounded-lg border border-brand-200 bg-brand-50 px-4 py-3 text-sm text-brand-800 dark:border-brand-500/30 dark:bg-brand-500/10 dark:text-brand-300">
      <span>{{ flash() }}</span>
      <button type="button" (click)="flash.set(null)" class="shrink-0 text-brand-700 hover:text-brand-900 dark:text-brand-400">✕</button>
    </div>
  }

  @if (error() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="error()"
      [loadingMessage]="'wallets.chargementDeTonWallet' | t"
      (retry)="fetch()"
    />
  } @else if (snapshot(); as snap) {
    <!-- Bandeau dette si CREDIT négatif -->
    @if (inDebt()) {
      <div class="rounded-2xl border border-error-200 bg-error-50 p-4 dark:border-error-800 dark:bg-error-500/10">
        <div class="flex items-start gap-3">
          <span class="text-error-600 dark:text-error-400">⚠️</span>
          <div class="flex-1">
            <p class="text-sm font-medium text-error-800 dark:text-error-300">
              {{ 'wallets.creditInDebt' | t: { amount: (snap.debt | number:'1.0-0') ?? '' } }}
            </p>
            <p class="mt-0.5 text-xs text-error-700 dark:text-error-400">
              {{ 'wallets.unePortionEquivalenteDe' | t }}
            </p>
          </div>
        </div>
      </div>
    }

    <!-- Grille 2 cartes + retrait -->
    <div class="grid gap-6 lg:grid-cols-2">
      <!-- CREDIT account -->
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-start justify-between gap-2">
          <div>
            <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">
              {{ accountTypeLabel[snap.credit.accountType] | t }}
            </p>
            <h3 class="mt-1 text-2xl font-bold dark:text-white/90"
                [class.text-error-700]="inDebt()"
                [class.dark:text-error-400]="inDebt()"
                [class.text-gray-800]="!inDebt()"
            >
              {{ snap.credit.balance | number:'1.0-0' }}
              <span class="text-sm font-normal text-gray-400">{{ snap.credit.currency || 'XOF' }}</span>
            </h3>
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Statut : {{ accountStatusLabel[snap.credit.accountStatus] | t }}
            </p>
          </div>
        </div>
        <a [routerLink]="detailLink(snap.credit.ownerRef)" class="mt-4 inline-flex items-center gap-1 text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">
          Voir l'historique →
        </a>
      </section>

      <!-- BALANCE account -->
      <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-start justify-between gap-2">
          <div>
            <p class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">
              {{ accountTypeLabel[snap.balance.accountType] | t }}
            </p>
            <h3 class="mt-1 text-2xl font-bold text-gray-800 dark:text-white/90">
              {{ snap.balance.balance | number:'1.0-0' }}
              <span class="text-sm font-normal text-gray-400">{{ snap.balance.currency || 'XOF' }}</span>
            </h3>
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Statut : {{ accountStatusLabel[snap.balance.accountStatus] | t }}
            </p>
          </div>
        </div>
        <div class="mt-4 rounded-xl border border-gray-100 bg-gray-50 p-3 dark:border-gray-800 dark:bg-white/[0.02]">
          <p class="text-[10px] uppercase tracking-wide text-gray-500 dark:text-gray-400">Retirable</p>
          <p class="mt-1 text-lg font-semibold text-brand-700 dark:text-brand-400">
            {{ snap.withdrawableBalance | number:'1.0-0' }}
            <span class="text-xs font-normal text-gray-400">XOF</span>
          </p>
          @if (inDebt()) {
            <p class="mt-1 text-[11px] text-error-600 dark:text-error-400">
              {{ 'wallets.frozenAmount' | t: { amount: (snap.debt | number:'1.0-0') ?? '' } }}
            </p>
          }
        </div>
        <a [routerLink]="detailLink(snap.balance.ownerRef)" class="mt-4 inline-flex items-center gap-1 text-xs font-medium text-brand-600 hover:text-brand-700 dark:text-brand-400">
          Voir l'historique →
        </a>
      </section>
    </div>

    <!-- Info pédagogique -->
    <section class="rounded-2xl border border-gray-100 bg-gray-50 p-5 text-sm text-gray-600 dark:border-gray-800 dark:bg-white/[0.02] dark:text-gray-300">
      <p class="mb-2 font-medium text-gray-800 dark:text-white/90">{{ 'wallets.aProposDeTes' | t }}</p>
      <ul class="ml-4 list-disc space-y-1 text-xs">
        <li><strong>CREDIT</strong> {{ 'wallets.creditExplain' | t }}</li>
        <li><strong>BALANCE</strong> {{ 'wallets.balanceExplain' | t }}</li>
        <li>{{ 'wallets.siTonCreditPasse' | t }}</li>
      </ul>
    </section>

    <!-- Mes retraits (#57) -->
    <section class="rounded-2xl border border-gray-200 bg-white shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="flex items-center justify-between gap-3 border-b border-gray-200 px-5 py-4 dark:border-gray-800">
        <h2 class="text-sm font-semibold text-gray-800 dark:text-white/90">{{ 'wallets.mesRetraits' | t }}</h2>
        @if (wTotalItems() > 0) {
          <span class="text-xs text-gray-500 dark:text-gray-400">{{ wTotalItems() }} demande(s)</span>
        }
      </div>

      @if (wLoading() && withdrawals().length === 0) {
        <p class="px-5 py-8 text-center text-sm text-gray-400">{{ 'wallets.chargement' | t }}</p>
      } @else if (withdrawals().length === 0) {
        <p class="px-5 py-8 text-center text-sm text-gray-400">{{ 'wallets.aucunRetraitPourL' | t }}</p>
      } @else {
        <div class="overflow-x-auto">
          <table class="w-full min-w-[640px] text-sm">
            <thead>
              <tr class="border-b border-gray-200 text-left text-xs uppercase tracking-wide text-gray-500 dark:border-gray-800 dark:text-gray-400">
                <th class="px-5 py-3 text-right font-medium">{{ 'wallets.montant' | t }}</th>
                <th class="px-5 py-3 font-medium">{{ 'wallets.statut' | t }}</th>
                <th class="px-5 py-3 font-medium">Destinataire</th>
                <th class="px-5 py-3 font-medium">{{ 'wallets.demande' | t }}</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
              @for (w of withdrawals(); track w.id) {
                <tr class="text-gray-700 dark:text-gray-300">
                  <td class="px-5 py-3 text-right font-semibold whitespace-nowrap text-gray-800 dark:text-white/90">{{ w.amount | number:'1.0-0' }} <span class="text-xs text-gray-400">{{ w.currency || 'XOF' }}</span></td>
                  <td class="px-5 py-3 whitespace-nowrap">
                    <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium {{ withdrawalStatusBadge[w.status] }}">{{ withdrawalStatusLabel[w.status] | t }}</span>
                    @if (w.status === 'REJECTED' && w.rejectReason) {
                      <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ w.rejectReason }}</p>
                    }
                  </td>
                  <td class="px-5 py-3 whitespace-nowrap font-mono text-xs text-gray-500 dark:text-gray-400">{{ w.recipientNumber || '—' }}</td>
                  <td class="px-5 py-3 whitespace-nowrap text-gray-500 dark:text-gray-400">{{ w.createdAt | ldate: 'dd/MM/yyyy HH:mm' }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (wTotalPages() > 1) {
          <div class="flex items-center justify-between gap-3 border-t border-gray-200 px-5 py-4 dark:border-gray-800">
            <p class="text-xs text-gray-500 dark:text-gray-400">Page {{ wPage() }} / {{ wTotalPages() }}</p>
            <div class="flex items-center gap-1">
              <button type="button" (click)="wGoToPage(wPage() - 1)" [disabled]="wPage() === 1" class="rounded-md px-3 py-1.5 text-sm text-gray-600 transition hover:bg-gray-50 disabled:opacity-40 dark:text-gray-300 dark:hover:bg-white/5">‹</button>
              <button type="button" (click)="wGoToPage(wPage() + 1)" [disabled]="wPage() === wTotalPages()" class="rounded-md px-3 py-1.5 text-sm text-gray-600 transition hover:bg-gray-50 disabled:opacity-40 dark:text-gray-300 dark:hover:bg-white/5">›</button>
            </div>
          </div>
        }
      }
    </section>
  }
</div>

<!--
  Modal de recharge CREDIT (WALLET_TOPUP).
  Flow : on appelle POST /payment/api/transactions/initiate avec metadata
  { type: WALLET_TOPUP, ownerType: OWNER, ownerRef }. La réponse contient un
  paymentUrl GUTouch qu'on ouvre dans un nouvel onglet. Au callback côté back,
  wallet-service consomme nawam.payment.result et crédite le CREDIT.
-->
<app-modal [isOpen]="topupOpen()" (close)="closeTopup()" className="max-w-md p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
    {{ debtPrefill() ? 'Payer ma dette' : 'Recharger mon CREDIT' }}
  </h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
    {{ 'wallets.leMontantSeraCredite' | t }}
  </p>

  @if (debtPrefill(); as amt) {
    <div class="mt-3 rounded-lg border border-warning-200 bg-warning-50 px-3 py-2 text-xs text-warning-800 dark:border-warning-800 dark:bg-warning-500/10 dark:text-warning-300">
      {{ 'wallets.votreOperateurVousDemande' | t }} <strong>{{ amt | number:'1.0-0' }} XOF</strong> {{ 'wallets.deDetteLeMontant' | t }}
    </div>
  }

  @if (topupError()) {
    <div class="mt-4 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ topupError() }}
    </div>
  }

  <form [formGroup]="topupForm" (ngSubmit)="submitTopup()" class="mt-5 space-y-4">
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'wallets.montant' | t }} <span class="text-error-500">*</span>
      </label>
      <div class="relative">
        <input
          type="number"
          formControlName="amount"
          min="100"
          step="100"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-4 pr-16 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
        />
        <span class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs text-gray-400">XOF</span>
      </div>
      @if (topupForm.controls.amount.invalid && topupForm.controls.amount.touched) {
        <p class="mt-1 text-xs text-error-600">{{ 'wallets.montantMinimum100Xof' | t }}</p>
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'wallets.methodeDePaiement' | t }} <span class="text-error-500">*</span>
      </label>
      @if (methodsLoading()) {
        <p class="text-xs text-gray-400">{{ 'wallets.chargementDesMethodes' | t }}</p>
      } @else if (methodOptions().length === 0) {
        <p class="text-xs text-warning-600 dark:text-warning-400">
          {{ 'wallets.aucuneMethodeDePaiement' | t }}
        </p>
      } @else {
        <app-pretty-select
          formControlName="serviceCode"
          [options]="methodOptions()"
          [placeholder]="'wallets.choisirUneMethode' | t"
        />
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ 'wallets.numeroDePaiement' | t }} <span class="text-error-500">*</span>
      </label>
      <input
        type="text"
        formControlName="recipientNumber"
        placeholder="+221 77 123 45 67"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
        {{ 'wallets.leNumeroAssocieA' | t }}
      </p>
    </div>

    <div class="rounded-xl border border-brand-100 bg-brand-50 p-3 text-xs text-brand-800 dark:border-brand-800 dark:bg-brand-500/10 dark:text-brand-300">
      {{ 'wallets.apresConfirmationUneNouvelle' | t }}
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <button
        type="button"
        (click)="closeTopup()"
        [disabled]="topupInitiating()"
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
      >
        {{ 'wallets.annuler' | t }}
      </button>
      <button
        type="submit"
        [disabled]="topupInitiating() || topupForm.invalid || methodOptions().length === 0"
        class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50"
      >
        @if (topupInitiating()) {
          <svg class="size-4 animate-spin" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle>
            <path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" class="opacity-75"></path>
          </svg>
          Initialisation…
        } @else {
          {{ 'wallets.continuerVersLePaiement' | t }}
        }
      </button>
    </div>
  </form>
</app-modal>

<!-- Modal de retrait BALANCE (#57) -->
<app-modal [isOpen]="withdrawOpen()" (close)="closeWithdraw()" className="max-w-md p-6">
  <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ 'wallets.retirerMaBalance' | t }}</h3>
  <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
    {{ 'wallets.leMontantEstVerse' | t }}
  </p>

  @if (snapshot(); as snap) {
    <div class="mt-3 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:border-gray-800 dark:bg-white/[0.02] dark:text-gray-300">
      {{ 'wallets.soldeRetirable' | t }} <strong class="text-brand-700 dark:text-brand-400">{{ snap.withdrawableBalance | number:'1.0-0' }} XOF</strong>
    </div>
  }

  @if (withdrawError()) {
    <div class="mt-4 rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ withdrawError() }}
    </div>
  }

  <form [formGroup]="withdrawForm" (ngSubmit)="submitWithdraw()" class="mt-5 space-y-4">
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'wallets.montant' | t }} <span class="text-error-500">*</span></label>
      <div class="relative">
        <input type="number" formControlName="amount" min="100" step="100"
          class="h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-4 pr-16 text-sm text-gray-800 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
        <span class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs text-gray-400">XOF</span>
      </div>
      @if (withdrawForm.controls.amount.hasError('max') && withdrawForm.controls.amount.touched) {
        <p class="mt-1 text-xs text-error-600">{{ 'wallets.montantSuperieurATon' | t }}</p>
      } @else if (withdrawForm.controls.amount.invalid && withdrawForm.controls.amount.touched) {
        <p class="mt-1 text-xs text-error-600">{{ 'wallets.montantMinimum100Xof' | t }}</p>
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'wallets.methodeDeVersement' | t }} <span class="text-error-500">*</span></label>
      @if (methodsLoading()) {
        <p class="text-xs text-gray-400">{{ 'wallets.chargementDesMethodes' | t }}</p>
      } @else if (methodOptions().length === 0) {
        <p class="text-xs text-warning-600 dark:text-warning-400">{{ 'wallets.aucuneMethodeDisponibleContacte' | t }}</p>
      } @else {
        <app-pretty-select formControlName="serviceCode" [options]="methodOptions()" [placeholder]="'wallets.choisirUneMethode' | t" />
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'wallets.numeroDestinataire' | t }} <span class="text-error-500">*</span></label>
      <input type="text" formControlName="recipientNumber" placeholder="+221 77 123 45 67"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">{{ 'wallets.leNumeroMobileMoney' | t }}</p>
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Motif (optionnel)</label>
      <input type="text" formControlName="reason" [placeholder]="'wallets.exRetraitDeMes' | t"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90" />
    </div>

    <div class="flex justify-end gap-2 pt-2">
      <button type="button" (click)="closeWithdraw()" [disabled]="withdrawSubmitting()" class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">{{ 'wallets.annuler' | t }}</button>
      <button type="submit" [disabled]="withdrawSubmitting() || withdrawForm.invalid || methodOptions().length === 0" class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
        @if (withdrawSubmitting()) {
          <svg class="size-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="opacity-25"></circle><path fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" class="opacity-75"></path></svg>
          Envoi…
        } @else { {{ 'wallets.demanderLeRetrait' | t }} }
      </button>
    </div>
  </form>
</app-modal>
